import {getProductsByCategoryId, getProductById} from '@/api/products.js'

export default {
  state: {
    currentCatgProducts: [],
    currentProduct: null,
  },
  mutations: {
    updateCurrentProducts(state, products) {
      state.currentCatgProducts = products;
    },
    updateCurrentProduct(state, product) {
      state.currentProduct = product;
    },
  },
  actions: {
    requestProductsByCategory({commit}, categoryId) {
      if (categoryId) {
        return new Promise(function(resolve, reject) {
          getProductsByCategoryId(categoryId).then(function(products) {
            commit('updateCurrentProducts', products);
            resolve();
          });
        });
      } else {
        // TODO : 최신상품 가져오기?
        commit('updateCurrentProducts', []);
      }
    },
    requestCurrentProductById({commit}, productId) {
      return new Promise(function(resolve, reject) {
        getProductById(productId).then(function(product) {
          commit('updateCurrentProduct', product);
          resolve();
        });
      });
    },
  },
}


// WEBPACK FOOTER //
// ./src/store/products.js